import { string } from "@amcharts/amcharts4/core";
import { coerceNumberProperty } from "@angular/cdk/coercion";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { SelectItem } from "primeng/api";
import { Action } from "../../../actiontracker/model/action.model";
import { AssignActionForSourcePost, AssignActionPost } from "../../../actiontracker/model/actionDetails.model";
import { ActionOwnerDAshboard } from "../../../actiontracker/model/actionOwnerDashboard.model";
import { Priority } from "../../../actiontracker/model/priority.model";
import { ActiontrackerConstantsService } from "../../../actiontracker/services/actiontracker-constants.service";
import { CategoryMappingData } from "../../../masterscreen/model/life-saving.model";
import { UnitTreeNode } from "../../../masterscreen/model/unit-tree.model";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { SpecificationData } from "../../../shared/components/category/category.component";
import { User, UserLogInActivity, UserLogInActivityDetails, UserPermissionParameters } from "../../../shared/models/user.model";
import { BaseService } from "../../../shared/services/base.service";
import { CommonService } from "../../../shared/services/common.service";
import { HseErrorHandlerService } from "../../../shared/services/hse-error-handler.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { Hazard } from "../../model/hazard.model";
import { Login } from "../../model/login.model";
import { AcknowledgmentRequest, ObservationRequest } from "../../model/observationData.model";
import { ObservationPermissions } from "../../model/observationPermissions.model";
import { ObservationType } from "../../model/observationType.model";
import { SearchText } from "../../model/searchTexts.model";
import { Usertypes } from "../../model/usertypes.model";
import { ObservationConstantsService } from "../../services/observation-constants.service";
import { ObservationService } from "../../services/observation.service";
import { ConstantsService } from "./../../../shared/services/constants.service";
import { PerformanceService } from '../../../performance-dashboard/services/performance.service';

@Component({
  selector: "ara-raise-observation",
  templateUrl: "./raise-observation.component.html",
  styleUrls: ["./raise-observation.component.css"],
})
export class RaiseObservationComponent implements OnInit {
  navigator = navigator;
  showbutton: boolean = false;
  actions: ActionOwnerDAshboard[];
  loggedInUserJSON: any;
  selectedUser: User;
  selectedUserEmp: User;
  selectedUserContractor: User;
  categoryValueSubmitted: boolean = false;
  Button: any = {
    showBackToDashboardButton: true,
    showResetButton: true,
    showBackButton: true,
    showSubmitButton: true,
    showUpdateButton: false,
  };
  userResults: User[] = [];
  popupMessage: string;
  refId: number;
  observationCheck: boolean;
  hazardCheck: boolean;
  display: boolean = false;
  value: string;
  observationFor: string;
  observationData: ObservationRequest;
  locations: SelectItem[];
  hazard: any[];
  company: any = {};
  login: Login;
  user: User;
  userTypes: Usertypes[] = [];
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  selectedObservationTypes: number[] = [];
  selectedHazardTypes: number[] = [];
  isLocationErrorMsg: boolean = false;
  isEmployeeNameErrorMsg: boolean = false;
  isContractorNameErrorMsg: boolean = false;
  isObservationDateErrorMsg: boolean = false;
  isObservationTypeErrorMsg: boolean = false;
  isWhatObserveErrorMsg: boolean = false;
  isAcknowledgmentReasonErrorMsg: boolean = false;
  isFeedbackErrorMsg: boolean = false;
  isWhatYouDidErrorMsg: boolean = false;
  isJobStoppedErrorMsg: boolean = false;
  isHazardErrorMsg: boolean = false;
  isObservationForDisplay: boolean = true;
  validate: boolean = true;
  title: string;
  searchTexts: SearchText;
  observationId: number = 0;
  sub: any;
  hazards: Hazard[];
  observationType: ObservationType[];
  showForSelf: boolean;
  showForEmp: boolean;
  showForContractor: boolean;
  selfObservationDataFlag: boolean;
  onBehalfEmpObservationDataFlag: boolean;
  onBehalfContractorObservationDataFlag: boolean;
  IsJobStopped: string;
  successDetails: string;
  errorDetails: any;
  alertType: string;
  dateTime = new Date();
  isDisplayObservationType: boolean = true;
  isHSEAdvisor: boolean = false;
  accept: string;
  multiple: boolean;
  @Input() isBackOfficeViewDetailsPage: any;
  @Output() submitRequestforBackOffice: EventEmitter<any> = new EventEmitter<
    any
  >();
  tempFiles: any[] = [];
  observationGroup: any;
  safeGroup: any;
  actBehaviourGroup: any;
  selectedObsType: any;
  circlehazards: any[] = [];
  trianglehazards: any[] = [];
  selectedtriangleHazardTypes: number[] = [];
  actionList: AssignActionForSourcePost[];
  actionPost: AssignActionForSourcePost;
  actionDetailsForHseAdvisor: ActionListForHSEAdvisor;
  hideActiondetailsOnEdit: boolean = false;
  selectedLocation: number = 0;
  observationAcknowledgeStatusId: number = 3;
  observationCategoryId: number = 1;
  prioritys: Priority[];
  assignAction = new Action();
  selectedActionOwner: any;
  selectedActionParty: any;
  selectedActionVerifier: any;
  actiondetails: string;
  actionTargetDate: Date;
  actionPriority: number;
  actionSourceId: number;
  deleteRecord: boolean = false;
  deleteActionId: number;
  cancelRecord: boolean = false;
  cancelActionId: number;
  confirmMessage: string;
  actionStatusId: number = 26;
  cancelStatusId: number = 25;
  showAckButton: boolean = false;
  editEnabled: boolean = true;
  updateactionList: AssignActionForSourcePost[] = [];
  showAck: string;
  userLogInActivityDetails: UserLogInActivityDetails;
  userActivityList: UserLogInActivity[];
  userpost: UserLogInActivity;
  newValue: string;
  oldValue: String;
  fieldName: string;
  retVal: any;
  updatedHazard: any[] = [];
  updatedType: any[] = [];
  status: string;
  isShowbuttons: boolean = false;
  isUpdateAllowed: boolean = false;
  isInactiveLocation: boolean = false;
  isShowOpen: boolean = false;
  raised: boolean = false;
  showMessage: boolean = false;
  reason: string = "";
  validateCancellationRemarks: boolean;
  restatereason: any;
  fileAttachments: any[] = [];
  displayId: string;
  didYouDoCheck: boolean = false;
  didYouSeeCheck: boolean = false;
  selectedIndex: any;
  improvedTypeCheck: boolean = false;
  WhatWeCouldDoFiles: any[];
  WhatYouDidFiles: any[];
  WhatObservedFiles: any[];
  disableObservation: boolean = false;
  permissions: ObservationPermissions = new ObservationPermissions();
  disableAddAction: boolean = false;
  selectedUnit: any;
  unitList: any[] = [];
  acknowledgeClicked: boolean = false;
  isReset: boolean;
  unitId: number = 0;
  observationIds: any[] = [];
  observationIndex: number = -1;
  isNext: boolean = true;
  isPrevious: boolean = true;
  independentPermissions: any;
  lifeSavingMappingRequest: CategoryMappingData;
  lifeSavingMappingByModuleIdData: any[];
  LifeSavingCategoriesTypeId: number;
  specificationDetailsData: SpecificationData;
  moduleId: number;
  moduleList: any[] = [];
  categoryCheckedValueData: any[] = [];
  specificationResponseData: SpecificationData;
  SpecificationLifeSavingruleId: any[] = [];
  sourceId: any;
  acknowledgeRequest: AcknowledgmentRequest;
  HseAdvisorFiles: any;
  unitTree: UnitTreeNode[];
  actionFiles: any[];
  isActive: boolean = false;
  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId : number;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;
  retValue: boolean;
  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  selectedContract: number = 0;
  hideContract : boolean=true;
  showContractValidation : boolean=false;
  isUnitEmployee:boolean=true;
  showDeletionmsg: boolean=false;
  showCancellationmsg: boolean=false;

  unitError : boolean;
  //EOC Pritesh
IsNewRecord:boolean = true;
  constructor(
    private activateRoute: ActivatedRoute,
    private observationService: ObservationService,
    private hseErrorHandler: HseErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router,
    private baseService: BaseService,
    private commonService: CommonService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private PDService: PerformanceService,
    private translate: TranslateService
  ) {
    this.selectedUserContractor = undefined;
    this.lifeSavingMappingRequest = new CategoryMappingData();
    this.specificationDetailsData = new SpecificationData();
    this.lifeSavingMappingByModuleIdData = [];
    this.showAck = activateRoute.snapshot.params["showAck"];
    this.dateTime.setDate(this.dateTime.getDate());
    // File format accepted and only single file allow at a time
    this.accept =
      ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS";
    this.multiple = true;
    this.selectedObsType = [];
    this.observationGroup = "4";
    this.safeGroup = "5";
    this.actBehaviourGroup = "6";
    this.actionDetailsForHseAdvisor = new ActionListForHSEAdvisor();
    this.userLogInActivityDetails = new UserLogInActivityDetails();
    this.userpost = new UserLogInActivity();
    this.actionPost = new AssignActionForSourcePost();
    this.actionList = [];
    this.userActivityList = [];
    this.actionList.push(this.actionPost);
    this.addAction();
    this.WhatWeCouldDoFiles = [];
    this.WhatYouDidFiles = [];
    this.WhatObservedFiles = [];
    this.specificationResponseData = new SpecificationData();
    this.acknowledgeRequest = new AcknowledgmentRequest();
    this.actionFiles = [];
  }
  

  ngOnInit() {
    //this.isPrevious = false;
    // this.baseService.showRootLoader = true;
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    // Check if Request come from back office - set default as On Behalf of Employee
    if (this.isBackOfficeViewDetailsPage) {
      this.observationFor =
        ObservationConstantsService.ObservationCardModuleConst.observationOnBehalfEmployee;
      this.setObservationForEdit(
        ObservationConstantsService.ObservationCardModuleConst
          .observationOnBehalfEmployee
      );
    } else {
      // auto-checked radio button
      this.observationFor =
        ObservationConstantsService.ObservationCardModuleConst.observationFor;
    }
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    //this.getUnitData();
    // if (this.loggedInUserJSON.UserTypes.UserType ===
    //   ObservationConstantsService.RequestFor.Contractor
    // ) 
         
    this.sub = this.route.params.subscribe((params) => {
      this.observationId = coerceNumberProperty(params["observationId"]);
      this.unitId = +params["unitId"];
      if (this.unitId) {
        this.getPermissionDetails(this.unitId);
      }
      this.getIsActiveUnit(this.unitId);
      // on edit, hide the details of action part
      if (this.observationId !== 0 && this.observationId) {
      
        this.IsNewRecord = false;
        this.hideActiondetailsOnEdit = true;
      }
    });
  
    this.getUnitData();
    this.observationData = new ObservationRequest();
    // Set routeURL and route name
    let routes = JSON.stringify(
      ObservationConstantsService.ObservationNavigation.InnerRoutes
    );
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes =
      ObservationConstantsService.ObservationNavigation.ReportRoutes;
    this.prioritys = ActiontrackerConstantsService.Priority.Priority;
    this.observationData.AcknowledgmentReason =
      "";
      this.observationData.Feedback =
      "";
    this.showAck = this.activateRoute.snapshot.params["showAck"];
    this.login = new Login();
    this.selectedUser = new User();
    this.selectedUserContractor = new User();
    this.selectedUserEmp = new User();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    this.observationData.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.IsJobStopped = "false";
    this.searchTexts = new SearchText();
    this.user = new User();
    this.selectedLocation = this.baseService.getItemFromSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName
    );
    this.actionList = [];
    this.sourceId = this.observationId;
    this.getUserTypes();
    this.addAction();
    this.captureSelectedUnit();
    this.getAllModules();
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    this.disableObservation = false;
  }
  getPermissionDetails(unitId) {
    
    let userPermissionParams: UserPermissionParameters = new UserPermissionParameters();
    userPermissionParams.UserId = this.loggedInUserJSON.UserId;
    userPermissionParams.ModuleId =
      ConstantsService.PermissionMatrixModules.Observation;
    userPermissionParams.UnitId = unitId;
    const apiRequest = {
      Model: userPermissionParams,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForUserPermissions.bind(this)
    );
  }
  callbackMethodForUserPermissions(response) {
    
    if (response) {
      this.permissions = new ObservationPermissions();
      if (response.Result.ObservationPermission) {
        this.permissions = response.Result.ObservationPermission;
        if (!this.permissions.OBS_Add && !this.permissions.OBS_Add_Unit && !this.permissions.OBS_Admin && !this.permissions.OBS_Admin_Unit) {
          this.routesFlag.find(s => s.routeName == ObservationConstantsService.ObservationCardModuleConst.MakeObservation).isClickable = false;
        }
      }

      if(!this.permissions.OBS_Add && !this.permissions.OBS_Add_Unit && !this.permissions.OBS_Admin && !this.permissions.OBS_Admin_Unit){
      this.isUpdateAllowed = false;
      }
      else{
        this.isUpdateAllowed = true;
      }
      
      if (this.observationId > 0) {
        if (this.observationData.RaisedBy === this.loggedInUserJSON.UserId) {
          this.permissions.OBS_Own = true;
        }
        if (
          !this.permissions.OBS_Admin &&
          !this.permissions.OBS_Admin_Unit &&
          ((this.permissions.OBS_Own &&
            this.observationData.Status === "Acknowledged") ||
            !this.permissions.OBS_Own)
        ) {
          this.disableObservation = true;
        }
        if (
          this.observationData.Status === "Cancelled" ||
          this.observationData.Status === "Deleted"
        ) {
          this.disableObservation = true;
        }
        if(this.permissions.OBS_Own && (this.observationData.Status === "New" || this.observationData.Status === "Draft" ))
        {
          this.disableObservation = false;
        }
        if(this.observationData.Status === "New" && !this.observationId){
          this.isActive = true;
        }
      }
    }
  }

  captureSelectedUnit() {
    this.baseService.unitListner.subscribe((data) => {
      this.ngOnInit();
    });
  }

  getIsActiveUnit(unitId) {
    
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {
    //console.log("response",response);

    this.editEnabled = response.Result[0]?.IsActive;
    
  }

  getUnitData() {
    this.baseService.showRootLoader = true
    const apiRequestUnit = {
      Model: {
        ModuleId: 4,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : this.IsNewRecord
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response) {
      this.unitList = response.Result;
    } else {
      this.unitList = JSON.parse(
        this.baseService.getItemFromSession("obs_Units")
      );
    }
    const apiRequest = {
      Model: {
        GetActiveNodes: this.IsNewRecord,
        UserId: this.loggedInUserJSON.UserId,
      },
    };
    this.masterscreenService.getTreeData(
      apiRequest,
      this.callbackMethodForGetTreeData.bind(this)
    );
    this.baseService.showRootLoader = false;
  }
  callbackMethodForGetTreeData(response) {

    if (response) {
      this.unitTree = response.Result;
    } else {
      this.unitTree = JSON.parse(
        this.baseService.getItemFromSession("unitTree")
      );
    }
    if (this.observationId === 0) {
      this.unitTree.forEach((element) => {
        this.compareTreeNode(element, 0);
      });
    }
    this.getcompany();
  }
  getUserTypes() {
    this.observationService.getUserTypes(
      this.callbackMethodForgetUserTypes.bind(this)
    );
  }
  callbackMethodForgetUserTypes(response) {
    if (response) {
      if (response.Error != null) {
        this.hseErrorHandler.handleError(response.Error);
      }
      if (response.Success) {
        this.userTypes = response.Result;
      }
    } else {
      this.userTypes = JSON.parse(
        this.baseService.getItemFromSession("userTypes")
      );
    }
  }
  getObservationDataByObservationId() {
    
    this.baseService.showRootLoader = true;
    if (navigator.onLine) {
      const apiRequest = {
        Model: {
          ObservationRequestId: this.observationId,
        },
      };
      this.observationService.getObservationRequest(
        apiRequest,
        this.callbackMethodForgetObservationRequest.bind(this)
      );
    } else {
      JSON.parse(
        this.baseService.getItemFromSession("storedObservations")
      ).forEach((obs) => {
        if (obs.ObservationId === this.observationId) {
          this.callbackMethodForgetObservationRequest({
            Result: obs,
            Success: true,
          });
        }
      });
      this.baseService.showRootLoader = false;
    }
  }

  callbackMethodForgetObservationRequest(response) {
    
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      // if (this.loggedInUserJSON.UserTypes.UserType ===
      //   ObservationConstantsService.RequestFor.Contractor && response.Result.RaisedBy != this.loggedInUserJSON.UserId
      // ) {
      //   this.notificationsService.toastNotify(
      //     "error",
      //     "Warning Message",
      //     "This Observation not raised by you, you don't have permission to view this record...!"
      //   );   
      //   this.router.navigate([
      //     ObservationConstantsService.RoutingURLConstant
      //       .ObservationDashboardURL,
      //   ]);
      //   return ; 
      // }
      this.observationData = response.Result;
      this.getIsActiveUnit(this.observationData.UnitId);
       this.observationService.setUpdatedObservationData(
       JSON.stringify(this.observationData)
       );
      this.reason = this.observationData.CancellationReason;
      this.unitTree.forEach((element) => {
      
        this.compareTreeNode(element, this.observationData.UnitId);
      });
      this.getPermissionDetails(this.selectedUnit.UnitId);
      
      this.getLocation();
      if (this.observationData.Status === "Draft") {
        this.observationData.IsDraft = true;
      }

      this.WhatWeCouldDoFiles = [];
      if (response.Result.WhatWeCouldDoFiles.length > 0) {
        this.WhatWeCouldDoFiles = response.Result.WhatWeCouldDoFiles;
      }
      this.WhatYouDidFiles = [];
      if (response.Result.WhatYouDidFiles.length > 0) {
        this.WhatYouDidFiles = response.Result.WhatYouDidFiles;
      }
      this.WhatObservedFiles = [];
      if (response.Result.WhatObservedFiles.length > 0) {
        this.WhatObservedFiles = response.Result.WhatObservedFiles;
      }
      this.HseAdvisorFiles = [];
      if (response.Result.WhatWeCouldDoFiles.length > 0) {
        this.HseAdvisorFiles = response.Result.HSEAdvisorFeedBackFiles;
      }
      if (this.observationData.RaisedBy === this.loggedInUserJSON.UserId) {
        this.permissions.OBS_Own = true;
      }
      
    if(this.observationData?.Status === "Acknowledged"){
      if (response.Result.AcknowledgmentReason !== ""){
        this.observationData.Feedback =
          this.observationData.AcknowledgmentReason;
      }
      else{
        this.observationData.Feedback = ""
      }
    }
    else if(this.observationData?.Status !== "Acknowledged"){
      if (response.Result.Feedback !== ""){
        this.observationData.Feedback =
        response.Result.Feedback;
      }
      else{
        this.observationData.Feedback = ""
      }
    }

      if (navigator.onLine) {
        this.getUserDetails();
      }
      this.selectedLocation = this.observationData.LocationId;
      if(this.selectedUnit.UnitTypeId == 2)
      {
        this.isUnitEmployee = false;
      }
      else
      {
        this.isUnitEmployee = true;
      }      
      this.getContractDetails(this.observationData.UnitId);
      this.selectedContract = this.observationData.Contract;
      this.observationData.ObservationDate = new Date(
        moment(moment.utc(this.observationData.ObservationDate).local()).format(
          "MMM D, YYYY LT"
        )
      );
      this.setSelectedHazardTypes();
      this.setSelectedObservationTypes();
      this.getActionsByObservationId();
      if (this.observationData.Status === "New") {
        this.showbutton = true;
      } else {
        this.showbutton = false;
      }
      this.IsJobStopped = this.observationData.IsJobStopped.toString();
      this.Button.showBackButton = false;
      this.Button.showResetButton = false;
      this.Button.showSubmitButton = false;
      this.Button.showBackToDashboardButton = true;
      this.Button.showUpdateButton = true;

      // let currentObservationData = this.observationData;
      // if (currentObservationData.WhatObservedFiles.length > 0) {
      //   currentObservationData.WhatObservedFiles.forEach(f => f.content = null);
      // }
      // if (currentObservationData.WhatWeCouldDoFiles.length > 0) {
      //   currentObservationData.WhatWeCouldDoFiles.forEach(f => f.content = null);
      // }
      // if (currentObservationData.WhatYouDidFiles.length > 0) {
      //   currentObservationData.WhatYouDidFiles.forEach(f => f.content = null);
      // }
      // this.observationService.setUpdatedObservationData(
      //   JSON.stringify(currentObservationData)
      // );

      this.observationIds = this.observationService.getAllObservationIds();
      if(this.observationIds == null){
        this.isNext = false;
        this.isPrevious = false;
      }
      let currentIndex: number = 0;
      if (this.observationIds) {
        this.observationIds.forEach((element, index) => {
          if (element.ObservationId === this.observationId) {
            currentIndex = index;
            return;
          }
        });
        if (currentIndex === 0) {
          this.isPrevious = false;
        }
        if (currentIndex === this.observationIds.length - 1) {
          this.isNext = false;
        }
      }
    }
    this.baseService.showRootLoader = false;
  }
  getActionsByObservationId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        ObservationRequestId: this.observationId,
      },
    };
    // Get all observation type data
    this.observationService.getActionsByObservationId(
      apiRequest,
      this.callbackMethodForgetActionsByObservationId.bind(this)
    );
  }
  /**
   * Callback  method to get action details by observationId
   * @param response - response of request.
   */
  callbackMethodForgetActionsByObservationId(response) {
    if (response && response.Success) {
      this.actionList = response.Result;
      //BOC Pritesh
      this.observationService.setoldActionData(
        JSON.stringify(this.actionList)
        );
      //EOC Pritesh  
      if (this.actionList.length > 0) {
        this.actionList.forEach((action) => {
          action.TargetDate = moment(
            moment.utc(action.TargetDate).local()
          ).toDate();
          action.ShowActionbuttons =
            action.Status === "Deleted" || action.Status === "Cancelled"
              ? true
              : false;
          action.FilesPreview = action.Files;
          action.Files = action.Files && action.Files.length ? action.Files : [];
        });
      } else {
        this.addAction();
      }
    } else {
      this.baseService.processApiResponseError(response);
    }
    this.baseService.showRootLoader = false;
  }

  getUserDetails() {
    const apiRequest = {
      Model: {
        UserId: this.observationData.RaisedFor,
        Email: null,
      },
    };
    this.observationService.getUserDetails(
      apiRequest,
      this.callbackMethodForgetUserDetails.bind(this)
    );
  }

  callbackMethodForgetUserDetails(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      let UserType = null;
      this.selectedUser = response.Result;
      if (this.selectedUser.UserTypes.UserTypeId !== null) {
        this.userTypes.forEach((userType) => {
          if (userType.UserTypeId === this.selectedUser.UserTypes.UserTypeId) {
            UserType = userType.UserType;
          }
        });
        switch (UserType) {
          case "Employee": {
            if (
              this.observationData.RaisedFor === this.loggedInUserJSON.UserId
            ) {
              this.observationFor =
                ObservationConstantsService.ObservationCardModuleConst.observationFor;
              this.selfObservationDataFlag = true;
            } else {
              this.observationFor =
                ObservationConstantsService.ObservationCardModuleConst.observationOnBehalfEmployee;
              this.onBehalfEmpObservationDataFlag = true;
              this.selectedUserEmp = this.selectedUser;
            }
            break;
          }
          case "Contractor": {
            this.observationFor =
              ObservationConstantsService.ObservationCardModuleConst.ObservationOnBehalfContractor;
            this.onBehalfContractorObservationDataFlag = true;
            this.showForContractor = true;
            this.selectedUserContractor = this.selectedUser;
            break;
          }
          default: {
            this.observationFor =
              ObservationConstantsService.ObservationCardModuleConst.observationFor;
            this.selfObservationDataFlag = true;
          }
        }
      }
    }
  }

  setSelectedHazardTypes() {
    this.observationData.HazardTypes.forEach((ht) => {
      this.hazards.forEach((hz) => {
        if (ht >= 1) {
          if (ht === hz.HazardId) {
            if (hz.HazardImageShape === "Circle") {
              this.selectedHazardTypes.push(hz.HazardId);
              hz.Checked = true;
            } else {
              this.selectedtriangleHazardTypes.push(hz.HazardId);
              hz.Checked = true;
            }
          }
        }
      })
    });
  }

  setSelectedObservationTypes() {
    if (!navigator.onLine) {
      this.observationData.ObservationTypeValue = this.observationData.ObservationTypes;
    }
    if (this.observationData.ObservationTypeValue.length > 0) {
      this.observationData.ObservationTypeValue.forEach((element) => {
        switch (element) {
          case 1:
            this.observationGroup = String(element);
            break;
          case 4:
            this.observationGroup = String(element);
            break;
          case 2:
            this.safeGroup = String(element);
            break;
          case 5:
            this.safeGroup = String(element);
            break;
          case 3:
            this.actBehaviourGroup = String(element);
            break;
          case 6:
            this.actBehaviourGroup = String(element);
            break;
        }
      });
      // this.observationGroup = String(this.observationData.ObservationTypeValue[0]);
      // this.safeGroup = String(this.observationData.ObservationTypeValue[1]);
      // this.actBehaviourGroup = String(this.observationData.ObservationTypeValue[2]);
      this.selectedObsType.push(parseInt(this.observationGroup, 10));
      this.selectedObsType.push(parseInt(this.safeGroup, 10));
      this.selectedObsType.push(parseInt(this.actBehaviourGroup, 10));
      this.observationData.ObservationTypes = this.selectedObsType;
      this.selectedObsType = [];
    }
  }

  setObservationForEdit(value) {
    switch (value) {
      case "self": {
        this.showForSelf = true;
        this.showForEmp = false;
        this.showForContractor = false;
        this.onBehalfEmpObservationDataFlag = false;
        this.onBehalfContractorObservationDataFlag = false;
        break;
      }
      case "onbehalfemp": {
        this.showForSelf = false;
        this.showForEmp = true;
        this.showForContractor = false;
        this.selfObservationDataFlag = false;
        this.onBehalfEmpObservationDataFlag = true;
        this.onBehalfContractorObservationDataFlag = false;
        this.getUsersOnSearch("");
        break;
      }
      case "onbehalfcontractor": {
        this.showForSelf = false;
        this.showForEmp = false;
        this.showForContractor = true;
        this.selfObservationDataFlag = false;
        this.onBehalfEmpObservationDataFlag = false;
        this.getUsersOnSearch("");
        break;
      }
    }
  }

  // method to check the validation
  checkValidation(isSubmit) 
  {
    this.baseService.showRootLoader = true;
    if (this.IsJobStopped === "true") {
      this.observationData.IsJobStopped = true;
    } else {
      this.observationData.IsJobStopped = false;
    }
    this.validate = true;

    this.unitError = true;
    if (this.selectedUnit != undefined){
    if (this.selectedUnit.UnitId) {
      this.unitError = false;
      this.validate = true;
    }}
    // set selected Observation type
    this.selectedObsType.push(parseInt(this.observationGroup, 10));
    this.selectedObsType.push(parseInt(this.safeGroup, 10));
    this.selectedObsType.push(parseInt(this.actBehaviourGroup, 10));
    this.observationData.ObservationTypes = this.selectedObsType;

    if (this.selectedHazardTypes.length === 0) {
      this.observationData.HazardTypes = this.selectedtriangleHazardTypes;
    } else {
      this.observationData.HazardTypes = this.selectedHazardTypes;
    }
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .observationOnBehalfEmployee
    ) {
      //if (this.selectedUserEmp == null ||(this.selectedUserEmp && this.selectedUserEmp.UserId === 0)) {
        if (this.selectedUserEmp.UserId === 0) {
        this.isEmployeeNameErrorMsg = true;
        this.validate = false;
      }
    }
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .ObservationOnBehalfContractor
    ) {
      //if (this.selectedUserContractor == null || (this.selectedUserContractor && this.selectedUserContractor.UserId === 0)) {
        if (this.selectedUserContractor.UserId === 0) {
        this.isContractorNameErrorMsg = true;
        this.validate = false;
      }
    }
    if (!this.observationData.LocationId) {
      this.isLocationErrorMsg = true;
      this.validate = false;
    }
    if (!this.observationData.ObservationDate) {
      this.isObservationDateErrorMsg = true;
      this.validate = false;
    }
    if (this.observationData.ObservationTypes.length === 0) {
      this.isObservationTypeErrorMsg = true;
      this.validate = false;
    }
    if (!this.observationData.WhatObserved) {
      this.isWhatObserveErrorMsg = true;
      this.validate = false;
    }  
    if(isSubmit === false){
    if (!this.observationData.Feedback) {
      this.isFeedbackErrorMsg = true;
      this.validate = false;
    }
  }
    if (!this.observationData.WhatYouDid) {
      this.isWhatYouDidErrorMsg = true;
      this.validate = false;
    }
    if (this.actionList[0].Action) {
      if (!this.validateAddAction()) {
        this.validate = false;
      }
    }
    //BOC Pritesh 
    if(!this.isUnitEmployee && this.selectedContract == 0)
    {
      this.showContractValidation = true;
      this.validate = false;
    }
    if(!this.isUnitEmployee && this.selectedContract != 0)
    {
      this.showContractValidation = false;
    }
    //EOC Pritesh 
    if (this.validate === true) {
      this.submitObservationCard();
    }
    else {
      this.baseService.showRootLoader = false;
    }
  }

  setObservationFor() {
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst.observationFor
    ) {
      this.observationData.RaisedFor = this.loggedInUserJSON.UserId;
    } else if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .observationOnBehalfEmployee
    ) {
      this.observationData.RaisedFor = this.selectedUserEmp.UserId;
    }
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .ObservationOnBehalfContractor
    ) {
      this.observationData.RaisedFor = this.selectedUserContractor.UserId;
    }
  }

  // method to submit the observation card data
  submitObservationCard() {
    this.baseService.showRootLoader = true;
    this.setObservationFor();
    if (this.observationData.ObservationId > 1) {
      this.observationData.RaisedBy = this.observationData.RaisedBy;
    } else {
      this.observationData.RaisedBy = this.loggedInUserJSON.UserId;
    }
    this.observationData.TimeZone = "Asia/Muscat";
    this.observationData.UnitId = this.selectedUnit.UnitId;
    if (this.observationData) {
      const apiRequest = {
        Model: this.observationData,
      };
      if (this.observationId > 0) {
        if (navigator.onLine) {
          apiRequest.Model.ObservationId = this.observationId;
          apiRequest.Model.CompanyId = this.loggedInUserJSON.Company.CompanyId;
          this.observationService.updateObservationData(
            apiRequest,
            this.callbackMethodForsubmitObservationData.bind(this)
          );
        } else {
          let storedObservations = JSON.parse(
            this.baseService.getItemFromSession("storedObservations")
          );
          let index = storedObservations
            .map(function (e) {
              return e.ObservationId;
            })
            .indexOf(this.observationId);
          storedObservations.splice(index, 1);
          storedObservations.push(this.observationData);
          this.baseService.setItemInSession(
            "storedObservations",
            JSON.stringify(storedObservations)
          );
          this.router.navigate([
            ObservationConstantsService.RoutingURLConstant
              .ObservationDashboardURL,
          ]);
        }
      } else {
        if (navigator.onLine) {
          this.observationService.submitObservationData(
            apiRequest,
            this.callbackMethodForsubmitObservationData.bind(this)
          );
        } else {
          let storedObservations = this.baseService.getItemFromSession(
            "storedObservations"
          );
          if (storedObservations === null || storedObservations === "null") {
            this.baseService.setItemInSession("currentObsId", 1);
            let newObservation = [];
            this.observationData.ObservationId = 1;
            newObservation.push(this.observationData);
            this.baseService.setItemInSession(
              "storedObservations",
              JSON.stringify(newObservation)
            );
            this.notificationsService.toastNotify(
              "info",
              "Information Message",
              "Observation is stored offline."
            );
          } else if (storedObservations !== null) {
            let existingObservations = JSON.parse(
              this.baseService.getItemFromSession("storedObservations")
            );
            let currentObsId = parseInt(
              this.baseService.getItemFromSession("currentObsId")
            );
            this.baseService.setItemInSession("currentObsId", currentObsId + 1);
            if (
              existingObservations !== "null" &&
              existingObservations !== null
            ) {
              this.observationData.ObservationId = currentObsId + 1;
              existingObservations.push(this.observationData);
              this.baseService.setItemInSession(
                "storedObservations",
                JSON.stringify(existingObservations)
              );
            } else {
              let newObservation = [];
              this.observationData.ObservationId = currentObsId + 1;
              newObservation.push(this.observationData);
              this.baseService.setItemInSession(
                "storedObservations",
                JSON.stringify(newObservation)
              );
            }
          }
          this.router.navigate([
            ObservationConstantsService.RoutingURLConstant
              .ObservationDashboardURL,
          ]);
        }
      }
    }
  }

  // call back method of submit observation
  callbackMethodForsubmitObservationData(response) {
    this.baseService.showRootLoader = false;
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      this.refId = response.Result;
      if(this.observationId > 0)
      {
        this.updateobservationData = JSON.parse(
          this.observationService.getUpdatedObservationData()
        );
        this.trackDetails(
          this.updateobservationData,
          this.observationData,
          "UpdateAction",
          false
        );
      }
      //this.trackDetails();//Pritesh
      if (this.observationId) {
        if (this.observationData.Status === "Draft") {
          this.notificationsService.toastNotify(
            "success",
            "Success Message",
            "Draft updated Successfully"
          );
          this.router.navigate([
            ObservationConstantsService.RoutingURLConstant
              .ObservationDashboardURL,
          ]);
        } else {
          if (!this.acknowledgeClicked && !this.showActions) {
            this.notificationsService.toastNotify(
              "success",
              "Success Message",
              "Observation card has been updated with observation reference Id as" +
              " " +
              "OBS" +
              this.refId
            );
            this.router.navigate([
              ObservationConstantsService.RoutingURLConstant
                .ObservationDashboardURL,
            ]);
          }
          if (
            this.observationId &&
            this.observationData.Feedback &&
            this.showAckButton &&
            this.observationData.Status === "Acknowledged"
          ) {
            this.notificationsService.toastNotify(
              "success",
              "Success Message",
              "Observation card has been updated with observation reference Id as" +
              " " +
              "OBS" +
              this.refId
            );
            this.router.navigate([
              ObservationConstantsService.RoutingURLConstant
                .ObservationDashboardURL,
            ]);
          }
          if (this.actionList.length >= 1) {
            this.notificationsService.toastNotify(
              "success",
              "Success Message",
              "Observation card has been updated with observation reference Id as" +
              " " +
              "OBS" +
              this.refId
            );
            this.updateAction();
            this.router.navigate([
              ObservationConstantsService.RoutingURLConstant
                .ObservationDashboardURL,
            ]);
          }
          // if (this.categoryCheckedValueData.length > 0) {
          //   this.categoryValueSubmitted = true;
          //   this.submitSpecificationData();
          // }
          this.observationData.IsDraft = false;
          this.observationData.IsUpdatedDraft = false;
        }
      } else if (this.refId) {
        if (this.observationData.IsDraft) {
          this.notificationsService.toastNotify(
            "success",
            "Success Message",
            "Draft saved successfully"
          );
        } else {
          this.notificationsService.toastNotify(
            "success",
            "Success Message",
            "Observation card has been created with observation reference Id as" +
            " " +
            "OBS" +
            this.refId
          );
          this.observationData.IsDraft = false;
          this.observationData.IsUpdatedDraft = false;
        }
        if (this.actionList.length >= 1) {
          this.updateAction();
        }
        this.showMessage = true;
      }

        this.submitSpecificationData();

      this.router.navigate([
        ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL,
      ]);
  
      this.baseService.showRootLoader = false;
    }

    if (response.Errors !== null) {
      // this.alertType = ConstantsService.Error;
      // this.errorDetails = 'Something went wrong. Please try again later.';
      // this.display = true;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        response.Errors[0].Message
      );
    }
    // if request submit from back office
    if (this.isBackOfficeViewDetailsPage) {
      this.submitRequestforBackOffice.emit();
    }
  }

  callbackMethodForupdateObservationData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      this.popupMessage =
        "Observation card has been updated for observation reference Id - ";
      this.refId = response.Result;
      // this.display = true;
    }

    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Please try again later."
      );
      this.hseErrorHandler.handleError(response.Errors);
      // this.popupMessage = 'Something went wrong. Please try again later.';
      // this.display = true;
    }
  }

  // method to get the location
  getLocation() {
    if (this.login) {
      this.login.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.observationId == 0 ? true : false,
        }
      };
      // Call dummy method to post data
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this)
      );
    }
  }

  // call back method of get location
  callbackMethodForGetLocationData(response) {
    let locationDetails = [];
    this.locations = [];
    if (response === undefined) {
      locationDetails = JSON.parse(
        this.baseService.getItemFromSession("locations_" + this.login.UnitId)
      );
    } else {
      if (response.Success) {
        locationDetails = response.Result;
      }
      if (response.Errors !== null) {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Location list is empty."
        );
        this.hseErrorHandler.handleError(response.Errors);
      }
    }
    locationDetails.forEach((location) => {
      this.locations.push({
        label: location.LocationName,
        value: location.LocationId,
        InActive :location?.InActive
      });
      if (location.LocationId=== this.selectedLocation) {
        this.observationData.LocationId = location.LocationId;
        this.isInactiveLocation = (location?.InActive === true)? true:false;
       
      }

    });
    
  }

  // method to get company name
  getcompany() {
    if (this.login) {
      const apiRequest = {
        Model: this.login,
      };
      this.observationService.getCompanyData(
        apiRequest,
        this.callbackMethodForgetCompanyData.bind(this)
      );
    }
  }

  // call back method of company name
  callbackMethodForgetCompanyData(response) {
    if (response === undefined) {
      this.company = JSON.parse(this.baseService.getItemFromSession("company"));
    } else {
      if (response.Success) {
        this.company = response.Result;
      }
      if (response.Result.CompanyId === 0) {
        this.display = true;
      }
    }
    
    this.getObservationTypeByCompanyId();
  }

  // method to store observation vale
  SubmitCheckedObservationValue(value, event): void {
    if (event.target.checked) {
      this.observationCheck = true;
      this.selectedObservationTypes = value.ObservationTypeId;
      value.Checked = true;
    }
  }

  // method to store hazard value
  SubmitCheckedHazardValue(value, event): void {
    if (event.target.checked) {
      this.hazardCheck = true;
      if (value.HazardImageShape === "Circle") {
        this.selectedHazardTypes.push(value.HazardId);
      } else {
        this.selectedtriangleHazardTypes.push(value.HazardId);
      }
      value.Checked = true;
    } else {
      const index = this.selectedHazardTypes.indexOf(value.HazardId);
      const ind = this.selectedtriangleHazardTypes.indexOf(value.HazardId);
      if (index > -1) {
        this.selectedHazardTypes.splice(index, 1);
        value.Checked = false;

        if (this.selectedHazardTypes.length === 0) {
          this.hazardCheck = false;
        }
      } else if (ind >= -1) {
        this.selectedtriangleHazardTypes.splice(index, 1);
        value.Checked = false;
        if (this.selectedtriangleHazardTypes.length === 0) {
          this.hazardCheck = false;
        }
      }
    }
  }

  setUserType() {
    switch (this.observationFor) {
      case ObservationConstantsService.ObservationCardModuleConst
        .observationOnBehalfEmployee:
        this.userTypes.forEach((userType) => {
          if (userType.UserType === "Employee") {
            this.searchTexts.UserTypeId = userType.UserTypeId;
          }
        });
        break;
      case ObservationConstantsService.ObservationCardModuleConst
        .ObservationOnBehalfContractor:
        this.userTypes.forEach((userType) => {
          if (userType.UserType === "Contractor") {
            this.searchTexts.UserTypeId = userType.UserTypeId;
          }
        });
        break;
      default:
        this.searchTexts.UserTypeId = 0;
    }
  }

  // method to get Employee's and Contractors name
  // this.getUserDetails('self');
  getUsersOnSearch(event) {
    if (this.loggedInUserJSON) {
      if (typeof event === "string" || event instanceof String) {
        this.searchTexts.FilterTexts = "";
      } else {
        this.searchTexts.FilterTexts = event.query;
      }
      this.searchTexts.CompanyId = 0;
      this.searchTexts.UserTypeId = 0;
      this.searchTexts.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: this.searchTexts,
      };
      this.observationService.getSearchResultsForUsers(
        apiRequest,
        this.callbackMethodForGetSearchResultsForUsersData.bind(this)
      );
    }
  }

  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }

    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Location list is empty."
      );
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  // method to get id of selected employee
  selectUser(event) {
    this.observationData.RaisedFor = event.UserId;
  }
  // method to reste the form data
  confirmResetForm() {
    this.isReset = true;
    this.alertType = ConstantsService.Confirm;
    this.confirmMessage =
      "You have clicked reset button. All information " +
      "entered by you on this page will be lost. Do you want to reset the form?";
  }

  resetForm() {
    this.observationData = new ObservationRequest();
    this.selectedLocation = this.baseService.getItemFromSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName
    );
    this.selectedUserEmp = null;
    this.selectedUserContractor = null;
    this.IsJobStopped = "false";
    this.selfObservationDataFlag = true;
    for (let index = 0; index < this.hazards.length; index++) {
      if (this.hazards[index].Checked === true) {
        this.hazards[index].Checked = false;
      }
    }
    for (let index = 0; index < this.observationType.length; index++) {
      if (this.observationType[index].Checked === true) {
        this.observationType[index].Checked = false;
      }
    }
    // Resets the observation type
    this.observationGroup = "4";
    this.safeGroup = "5";
    this.actBehaviourGroup = "6";

    this.user = null;
    this.actionList.forEach((action) => {
      action.Action = null;
      action.ActionOwner = null;
      action.selectedActionParty = null;
      action.selectedActionVerifier = null;
      action.Priority = 2;
      action.TargetDate = new Date();
    });
  }

  // Shows error message when service is not available ( WebAPIs are not in running mode)
  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }

  // call when you click on ok of msg popup
  onOkClicked() {
    this.router.navigate([
      ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL,
    ]);
  }
  onNoClickedForConfirmation() {
    this.alertType = "";
    this.confirmMessage = "";
  }
  onYesClickedForConfirmation() {
    if (this.isReset) {
      this.resetForm();
      this.alertType = "";
      this.confirmMessage = "";
    } else {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ObservationRequestId: this.observationId,
          Status: ObservationConstantsService.ObservationStatus.Cancelled,
          Reason: this.reason,
          CancelledBy: this.loggedInUserJSON.UserId,
        },
      };
      this.observationService.cancelObservationRequest(
        apiRequest,
        this.callbackMethodForCancelObservationRequest.bind(this)
      );
    }
  }
  //#region- get Observation Type from configuration
  getObservationTypeByCompanyId() {
    
    const apiRequest = {
      Model: {
        companyId: this.loggedInUserJSON.Company.CompanyId,
      },
    };
    // Get all observation type data
    this.observationService.getObservationTypeByCompanyId(
      apiRequest,
      this.callbackMethodForGetObservationTypeDetails.bind(this)
    );
  }

  /**
   * Callback method of observation type details.
   * @param response - response of request.
   */
  callbackMethodForGetObservationTypeDetails(response) {
    
    if (response) {
      if (response.Success) {
        this.observationType = response.Result;
      } else {
        this.baseService.processApiResponseError(response);
      }
    } else {
      this.observationType = JSON.parse(
        this.baseService.getItemFromSession("obsTypes")
      );
    }
    const updated = this.observationType;
    updated.forEach((observe) => {
      this.updatedType.push({
        label: observe.ObservationTypeName,
        value: observe.ObservationTypeId,
      });
    });
    this.getHazardTypeByCompanyId();
  }
  //#endregion

  //#region- get Observation Type from configuration
  getHazardTypeByCompanyId() {
    const apiRequest = {
      Model: {
        CompanyId: 1,
      },
    };
    // Get all observation type data
    this.observationService.getHazardTypeByCompanyId(
      apiRequest,
      this.callbackMethodForGetHazardTypeDetails.bind(this)
    );
  }

  /**
   * Callback method of observation type details.
   * @param response - response of request.
   */
  callbackMethodForGetHazardTypeDetails(response) {
    
    this.trianglehazards = [];

    this.circlehazards = [];
    if (response) {
      if (response.Success) {
        this.hazards = response.Result;
      } else {
        this.baseService.processApiResponseError(response);
      }
    } else {
      this.hazards = JSON.parse(this.baseService.getItemFromSession("hazards"));
    }
    let i;
    const updated = this.hazards;
    updated.forEach((hazard) => {
      this.updatedHazard.push({
        label: hazard.HazardName,
        value: hazard.HazardId,
      });
    });
    if (this.hazards.length > 0) {
      for (i = 0; i < this.hazards.length; i++) {
        if (this.hazards[i].HazardImageShape === "Triangle") {
          this.trianglehazards.push(this.hazards[i]);
        } else {
          this.circlehazards.push(this.hazards[i]);
        }
      }
    }
    if (this.observationId > 0) {
      this.getObservationDataByObservationId();
    }
  }
  //#endregion

  //#region - add action for Hse Advisor
  bindActionOwnerIdToList() {
    this.actionList.forEach((action) => {
      if (action.ActionOwner.UserId !== 0) {
        action.ActionOwnerId = action.ActionOwner.UserId;
        action.UnitId = this.selectedUnit.UnitId;
      }
    });
  }
  // To get id of selected action party
  selectActionParty(event, index) {
    if (!event.UserId) {
      this.actionList[index].selectedActionParty = new User();
      this.actionList[index].selectedActionParty.UserId = 0;
      this.actionList[index].selectedActionParty.FullName = "";
    } else {
      this.actionList[index].ShowActionPartyErrorMessage = false;
    }
  }
  // To get id of selected action verifier
  selectActionVerifier(event, index) {
    if (!event.UserId) {
      this.actionList[index].selectedActionVerifier = new User();
      this.actionList[index].selectedActionVerifier.UserId = 0;
      this.actionList[index].selectedActionVerifier.FullName = "";
    } else {
      this.actionList[index].ShowActionVerifierErrorMessage = false;
    }
  }
  // To get id of selected action owner
  selectActionOwner(event, index: number) {
    if (event.UserId) {
      this.actionList[index].selectedActionParty = new User();
      // this.actionList[index].selectedActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName,
      //   ContractNumber:event.contractNumber,
      //   UserTypeName:event.userTypeName
      // };
      this.actionList[index].ShowActionOwnerErrorMessage = false;
      this.actionList[index].ShowActionPartyErrorMessage = false;
    } else {
      this.actionList[index].ActionOwner = new User();
      this.actionList[index].ActionOwner.UserId = 0;
      this.actionList[index].ActionOwner.FullName = "";
    }
  }

  // Add Action on +addaction
  addAction() {
    this.actionPost = new AssignActionForSourcePost();
    this.actionList.push(this.actionPost);
  }
  // remove from action list
  removeActionFromActionList(index) {
    if (this.actionList.length > 1) {
      this.actionList.splice(index, 1);
    }
  }

  // Insert Action for Hse Advisor
  insertActionDetailsForHseAdvisor() {
    let hasEmptyActions: boolean = true;
    while (hasEmptyActions) {
      for (var i = 0; i < this.actionList.length; i++) {
        if (this.actionList[i].Action === "") {
          this.actionList.splice(i, 1);
          break;
        } else {
          this.actionList[i].UnitId = parseInt(this.selectedUnit.UnitId);
        }
      }
      hasEmptyActions = false;
    }
    this.bindActionOwnerIdToList();
    if (this.observationId > 0) {
      this.actionDetailsForHseAdvisor.SourceId = this.observationId;
    } else {
      this.actionDetailsForHseAdvisor.SourceId = this.refId;
    }

    this.actionDetailsForHseAdvisor.ActionDetails = this.actionList;
    this.actionDetailsForHseAdvisor.RaisedBy = this.loggedInUserJSON.UserId;
    if (
      this.actionDetailsForHseAdvisor.ActionDetails !== null &&
      this.actionDetailsForHseAdvisor.ActionDetails.length > 0
    ) {
      const apiRequest = {
        Model: this.actionDetailsForHseAdvisor,
      };
      this.observationService.insertActionAssignedByHseAdvisor(
        apiRequest,
        this.callbackFromInsertActionHseAdvisor.bind(this)
      );
    }
  }

  callbackFromInsertActionHseAdvisor(response) {
    if (response) {
      if (!this.showMessage) {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Observation card has been updated with observation reference Id as" +
          " " +
          "OBS" +
          this.actionDetailsForHseAdvisor.SourceId
        );
        this.router.navigate([
          ObservationConstantsService.RoutingURLConstant
            .ObservationDashboardURL,
        ]);
        // this.successDetails = 'Observation card has been updated with observation reference Id as' + ' ' + 'OBS' + this.actionDetailsForHseAdvisor.SourceId;
      }
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Sorry, we could not save actions."
      );
      this.baseService.processApiResponseError(response);
      // this.alertType = ConstantsService.Error;
      // this.errorDetails = 'Sorry, we could not save actions.';
    }
  }
  validateAddAction(): boolean {
    let isFormValid = true;
    // Action error messages
    this.actionList.forEach((action) => {
      if (action.Action.trim() === "") {
        action.ShowActionErrorMessage = true;
        isFormValid = false;
      }
      if (action.ActionOwner.UserId === 0) {
        action.ShowActionOwnerErrorMessage = true;
        isFormValid = false;
      }
      if (action.selectedActionParty.UserId === 0) {
        action.ShowActionPartyErrorMessage = true;
        isFormValid = false;
      }
      // if (!action.selectedActionVerifier) {
      //     action.ShowActionVerifierErrorMessage = true;
      //     isFormValid = false;
      // }
      if (action.Priority === 0) {
        action.ShowPriorityErrorMessage = true;
        isFormValid = false;
      }
      if (!action.TargetDate) {
        action.ShowTargetErrorMessage = true;
        isFormValid = false;
      }
    });
    return isFormValid;
  }
  //#endregion
  saveLocation() {
    this.baseService.setItemInSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName,
      this.selectedLocation
    );
    this.locations.forEach((location) => {
      if (location.value === this.selectedLocation) {
        this.observationData.LocationId = location.value;
        this.isInactiveLocation = (location?.InActive === true)? true:false;
      }
    });
  }
  acknowledgeObservationRequest() {

    this.checkValidation(false);
    this.acknowledgeRequest.ObservationRequestId = this.refId
      ? this.refId
      : this.observationData.ObservationId;
    this.acknowledgeRequest.HSEAdvisorFeedBackFiles = this.observationData.HSEAdvisorFeedBackFiles;
    this.acknowledgeRequest.AcknowledgedBy = this.loggedInUserJSON.UserId;
    this.acknowledgeRequest.AcknowledgmentReason = this.observationData.Feedback;
    this.acknowledgeRequest.IpAddress =this.baseService.getItemFromSession('ipAddress') ; 
     if(this.validate){
      this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: this.acknowledgeRequest,
    };
    this.observationService.acknowledgeObservationRequest(
      apiRequest,
      this.callbackMethodForAcknowledgeObservationRequest.bind(this)
    );
  }
}
  callbackMethodForAcknowledgeObservationRequest(response) {
    this.baseService.showRootLoader = false;
    if (response.Success) {
        if (!this.refId) {
          // this.alertType = ConstantsService.Success;
          this.notificationsService.toastNotify(
            "success",
            "Success Message",
            "Observation acknowledged successfully"
          );
          //this.router.navigate([ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL]);
          // this.successDetails = 'Observation acknowledged successfully';
          // this.display = true;

          
        }      
      this.savePDF();
      //this.router.navigate([ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL]);
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Please try again later."
      );

      // this.alertType = ConstantsService.Error;
      // this.errorDetails = 'Something went wrong. Please try again later.';
      // this.display = true;
    }
  }
  //update Action
  updateAction() {
    this.bindActionOwnerIdToList();
    if (this.observationId > 0) {
      this.actionDetailsForHseAdvisor.SourceId = this.observationId;
    } else {
      this.actionDetailsForHseAdvisor.SourceId = this.refId;
    }
    let hasEmptyActions: boolean = true;
    while (hasEmptyActions) {
      for (var i = 0; i < this.actionList.length; i++) {
        if (this.actionList[i].Action === "") {
          this.actionList.splice(i, 1);
          break;
        } else {
          this.actionList[i].UnitId = parseInt(this.selectedUnit.UnitId);
        }
      }
      hasEmptyActions = false;
    }
    for (var i = 0; i < this.actionList.length; i++) {
      if (
        this.actionList[i].Status !== "Deleted" &&
        this.actionList[i].Status !== "Cancelled" &&
        this.actionList[i].Status !== "Closed" &&
        this.actionList[i].Action !== ""
      ) {
        this.updateactionList.push(this.actionList[i]);
      }
    }
    if (this.updateactionList.length >= 1) {
      this.actionDetailsForHseAdvisor.ActionDetails = this.updateactionList;
    } else {
      this.actionDetailsForHseAdvisor.ActionDetails = this.actionList;
    }
    this.actionDetailsForHseAdvisor.RaisedBy = this.loggedInUserJSON.UserId;
    if (
      this.actionDetailsForHseAdvisor.ActionDetails !== null &&
      this.actionDetailsForHseAdvisor.ActionDetails.length > 0
    ) {
      this.actionDetailsForHseAdvisor.ProcessName =
        ObservationConstantsService.ObservationCardModuleConst.Observation;
      const apiRequest = {
        Model: this.actionDetailsForHseAdvisor,
      };
      this.observationService.updateActionAssignedByHseAdvisor(
        apiRequest,
        this.callbackFromUpdateActionHseAdvisor.bind(this)
      );
    }
  }
  callbackFromUpdateActionHseAdvisor(response) {
    if (response.Success) {
      // this.alertType = ConstantsService.Success;
      this.router.navigate([
        ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL,
      ]);
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Please try again later."
      );
      // this.alertType = ConstantsService.Error;
      // this.errorDetails = 'Something went wrong. Please try again later.';
      // this.display = true;
    }
  }
  cancelAssigned(actionId, index) {
    this.cancelRecord = true;
    this.cancelActionId = actionId;
  }

  cancelAction(cancelActionId) {
    if (this.cancelActionId > 1 && this.observationData.CancellationReason != ''
      && this.observationData.CancellationReason != undefined
      && this.observationData.CancellationReason != null
    ) {
      this.cancelRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.cancelActionId,
          CancellationReason: this.observationData.CancellationReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.cancelStatusId,
        },
      };
      this.observationService.cancelactiondetails(
        apiRequest,
        this.callbackMethodForCancelActionDetails.bind(this)
      );
    }
    else 
    if (this.observationData.CancellationReason === '') {
      this.showCancellationmsg = true;
     
    }
  }
  callbackMethodForCancelActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.cancelRecord = false;
    this.observationData.CancellationReason = "";
    this.ngOnInit();
  }
  onCancel() {
    this.cancelRecord = false;
    this.observationData.CancellationReason = "";
  }
  deleteAssigned(actionId, index) {
    if (actionId === 0) {
      this.actionList.splice(index, 1);
    } else {
      this.deleteRecord = true;
      this.deleteActionId = actionId;
    }
  }
  deleteAction(deleteActionId) {
    if (this.deleteActionId > 1 && this.observationData.DeletionReason != ""
      && this.observationData.DeletionReason != undefined
      && this.observationData.DeletionReason != null  
    ) {
      this.deleteRecord = true;
      this.baseService.showRootLoader = true;
      
      const apiRequest = {
        Model: {
          ActionId: this.deleteActionId,
          DeletionReason: this.observationData.DeletionReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.actionStatusId,
        },
      };
      this.observationService.deleteactiondetails(
        apiRequest,
        this.callbackMethodForDeleteActionDetails.bind(this)
      );
    }
    else 
    if (this.observationData.DeletionReason=== "") {
      this.showDeletionmsg = true;
     
    }
  }
  callbackMethodForDeleteActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.deleteRecord = false;
    this.observationData.DeletionReason = "";
    this.ngOnInit();
  }
  isNew: boolean = false;
  onCancelClick() {
    this.deleteRecord = false;
    this.observationData.DeletionReason = "";
  }
  updateobservationData;
  oldActionData;//Pritesh
  actionIds;//Pritesh
  trackDetails(OldValue, NewValue, action, isNew) {
    
    const columnNames = Object.getOwnPropertyNames(this.observationData);
    columnNames.forEach((element) => {
      if (OldValue.length === 0) {
        this.retVal = false;
        // OldValue = null;
      } else {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
      }
      if (this.retVal === false) {
      
      if (element === "ObservationTypes") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        this.updatedType.forEach((observe) => {
          this.observationData[element].forEach((observeid) => {
            if (observe.value === observeid) {
              userLoginActivity.NewValue += observe.label + ",";
            }
          });
          if (this.updateobservationData) {
            this.updateobservationData["ObservationTypeValue"].forEach((observeid) => {
              if (observe.value === observeid) {
                userLoginActivity.OldValue += observe.label + ",";
              }
            });
          } else {
            userLoginActivity.OldValue = null;
          }
        });
        if(userLoginActivity.OldValue != userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      }
      else if (element === "UnitName") {
      
         const userLoginActivity = new UserLogInActivity();
         userLoginActivity.FieldName = element;
         userLoginActivity.OldValue = isNew ? null : OldValue[element];
         userLoginActivity.NewValue = NewValue[element];
         this.userActivityList.push(userLoginActivity);
       
     }
     else if (element === "UnitId") {
      
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = element;
      userLoginActivity.OldValue = (OldValue[element] == undefined || OldValue[element] == null) ? 0 : OldValue[element];
      userLoginActivity.NewValue = (NewValue[element] == undefined || NewValue[element] == null) ? 0 : NewValue[element];
      this.userActivityList.push(userLoginActivity);
    
  }
     else if (element === "IsJobStopped") {
      
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = "Is Job Stopped";
      userLoginActivity.OldValue = isNew ? null : OldValue[element];
      userLoginActivity.NewValue = NewValue[element];
      this.userActivityList.push(userLoginActivity);
    
  }
  else if (element === "Status") {
      
    const userLoginActivity = new UserLogInActivity();
    userLoginActivity.FieldName = element;
    userLoginActivity.OldValue = isNew ? null : OldValue[element];
    userLoginActivity.NewValue = NewValue[element];
    this.userActivityList.push(userLoginActivity);
  
    }
     else if (element === "ExactLocation") {
     
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = element;
       userLoginActivity.OldValue = isNew ? null : OldValue[element];
       userLoginActivity.NewValue = NewValue[element];
       this.userActivityList.push(userLoginActivity);
     
   }
   else if (element === "WhatObserved") {
    
     const userLoginActivity = new UserLogInActivity();
     userLoginActivity.FieldName = element;
     userLoginActivity.OldValue = isNew ? null : OldValue[element];
     userLoginActivity.NewValue = NewValue[element];
     this.userActivityList.push(userLoginActivity);
   
 }
 else if (element === "WhatYouDid") {
  
   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}
else if (element === "WhatWeCouldDo") {
 
   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}
else if (element === "WhatIsTheReason") {
 
   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}

else if (element === "RaisedFor") {
 
   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = "Contractor Name";
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}

else if (element === "Contract") {
 
  const userLoginActivity = new UserLogInActivity();
  userLoginActivity.FieldName = "Contract Number";
  userLoginActivity.OldValue = OldValue[element];
  userLoginActivity.NewValue = NewValue[element];
  this.userActivityList.push(userLoginActivity);

}

       else if (element === "HazardTypes") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        this.updatedHazard.forEach((hazard) => {
          this.observationData[element].forEach((hazardid) => {
            if (hazard.value === hazardid) {
              userLoginActivity.NewValue += hazard.label + ",";
            }
          });
          if (this.updateobservationData) {
            this.updateobservationData[element].forEach((hazardid) => {
              if (hazard.value === hazardid) {
                userLoginActivity.OldValue += hazard.label + ",";
              }
            });
          } else {
            userLoginActivity.OldValue = null;
          }
        });
        this.userActivityList.push(userLoginActivity);
      } 
      else if (element === "LocationId") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        this.locations.forEach((location) => {
          if (location.value === this.observationData[element]) {
            userLoginActivity.NewValue = location.label;
          }
          if (this.updateobservationData) {
            if (location.value === this.updateobservationData[element]) {
              userLoginActivity.OldValue = location.label;
            }
          } else {
            userLoginActivity.OldValue = null;
          }
        });
        this.userActivityList.push(userLoginActivity);
      } else if (
        element === "TimeZone" ||
        element === "ObservationRaiseUser" ||
        element === "ObservationTypeValue" ||
        element === "ObservationDate"
      ) {
        
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = element;
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        }
      } else if (element === "WhatYouDidFiles") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (this.updateobservationData) {
          for (var i = 0; i < this.updateobservationData[element].length; i++) {
            const url = this.updateobservationData.WhatYouDidFiles[i].Name;
            userLoginActivity.OldValue += url + ",";
          }
        } else {
          userLoginActivity.OldValue = null;
        }
        for (var i = 0; i < this.observationData[element].length; i++) {
          let url1 = this.observationData.WhatYouDidFiles[i].Name;
         
          userLoginActivity.NewValue += url1 + ",";
        }
        if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      } else if (element === "WhatWeCouldDoFiles") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (this.updateobservationData) {
          for (var i = 0; i < this.updateobservationData[element].length; i++) {
            const url = this.updateobservationData.WhatWeCouldDoFiles[i]
              .Name;
            userLoginActivity.OldValue += url + ",";
          }
        } else {
          userLoginActivity.OldValue = null;
        }
        for (var i = 0; i < this.observationData[element].length; i++) {
          let url1 = this.observationData.WhatWeCouldDoFiles[i].Name;
         
          userLoginActivity.NewValue += url1 + ",";
        }
        if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      } else if (element === "WhatObservedFiles") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (this.updateobservationData) {
          for (var i = 0; i < this.updateobservationData[element].length; i++) {
            const url = this.updateobservationData.WhatObservedFiles[i]
              .Name;
            userLoginActivity.OldValue += url + ",";
          }
        } else {
          userLoginActivity.OldValue = null;
        }
        for (var i = 0; i < this.observationData[element].length; i++) {
          let url1 = this.observationData.WhatObservedFiles[i].Name;
         
          userLoginActivity.NewValue += url1 + ",";
        }
        if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      } else {
       
      }
    }
    });

    //BOC Pritesh
    this.oldActionData = JSON.parse(
      this.observationService.getoldActionData()
    );
    
  
    for(var i=0;i<this.actionList.length;i++)
    {
                 
       //Action Description Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = "Action Description - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
       userLoginActivity.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Action : ""; 
       userLoginActivity.NewValue = this.actionList[i] != undefined ? this.actionList[i].Action : "";
       if(userLoginActivity.OldValue != userLoginActivity.NewValue)
       {
         this.userActivityList.push(userLoginActivity);
       }
               
       //Action Owner Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = "Action Owner - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId );
       userLoginActivity1.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].ActionOwner.FullName : ""; 
       userLoginActivity1.NewValue = this.actionList[i] != undefined ? this.actionList[i].ActionOwner.FullName : "";
       if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
       {
         this.userActivityList.push(userLoginActivity1);
       }

        //Action Party Comparison
        const userLoginActivity2 = new UserLogInActivity();
        userLoginActivity2.FieldName = "Action Party - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
        userLoginActivity2.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionParty.FullName : ""; 
        userLoginActivity2.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionParty.FullName : "";
        if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
        {
          this.userActivityList.push(userLoginActivity2);
        }

         //Action Verifier Comparison
         const userLoginActivity3 = new UserLogInActivity();
         userLoginActivity3.FieldName = "Action Verifier - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
         userLoginActivity3.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionVerifier.FullName : ""; 
         userLoginActivity3.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionVerifier.FullName : "";
         if(userLoginActivity3.OldValue != userLoginActivity3.NewValue)
         {
           this.userActivityList.push(userLoginActivity3);
         }

          //Action Priority Comparison
          const userLoginActivity4 = new UserLogInActivity();
          userLoginActivity4.FieldName = "Action Priority - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          userLoginActivity4.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Priority : ""; 
          if(userLoginActivity4.OldValue.toString() === "1")
          {
            userLoginActivity4.OldValue = "Low";
          }
          else if(userLoginActivity4.OldValue.toString() === "2")
          {
            userLoginActivity4.OldValue = "Medium";
          }
          else if(userLoginActivity4.OldValue.toString() === "3")
          {
            userLoginActivity4.OldValue = "High";
          }
          userLoginActivity4.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].Priority : "") : "";
          if(userLoginActivity4.NewValue.toString() === "1")
          {
            userLoginActivity4.NewValue = "Low";
          }
          else if(userLoginActivity4.NewValue.toString() === "2")
          {
            userLoginActivity4.NewValue = "Medium";
          }
          else if(userLoginActivity4.NewValue.toString() === "3")
          {
            userLoginActivity4.NewValue = "High";
          }
          if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
          {
            this.userActivityList.push(userLoginActivity4);
          }
          
        //Action Target Date Comparison
         const userLoginActivity5 = new UserLogInActivity();
         userLoginActivity5.FieldName = "Action Target Date - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
         userLoginActivity5.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].TargetDate : ""; 
         if(userLoginActivity5.OldValue !== "")
         {
          userLoginActivity5.OldValue = moment(
            moment.utc(userLoginActivity5.OldValue).local()
          ).toDate();
         }
         userLoginActivity5.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].TargetDate : "") : "";
         if(userLoginActivity5.NewValue !== "")
         {
          userLoginActivity5.NewValue = moment(
            moment.utc(userLoginActivity5.NewValue).local()
          ).toDate();
         }
         if(userLoginActivity5.OldValue != userLoginActivity5.NewValue)
         {
           this.userActivityList.push(userLoginActivity5);
         }

          //Action Files Comparison
          const userLoginActivity6 = new UserLogInActivity();
          userLoginActivity6.FieldName = "Action Files - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          if (this.oldActionData[i] != undefined && this.oldActionData[i].Files.length > 0) {
            for (var j = 0; j < this.oldActionData[i].Files.length; j++) {
              const url = this.oldActionData[i].Files[j]
                .Name;
              userLoginActivity6.OldValue += url + ",";
            }
          } else {
            userLoginActivity6.OldValue = "";
          }
          if (this.actionList[i] != undefined && this.actionList[i].Files.length > 0) {
            for (var j = 0; j < this.actionList[i].Files.length; j++) {
              const url = this.actionList[i].Files[j]
                .Name;
              userLoginActivity6.NewValue += url + ",";
            }
          } else {
            userLoginActivity6.NewValue = "";
          }
          if(userLoginActivity6.OldValue != userLoginActivity6.NewValue)
          {
            this.userActivityList.push(userLoginActivity6);
          }
    }
   

    //EOC Pritesh

    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.isNew ? this.refId : this.observationId,
        new Date(),
        "Observation",
        this.loggedInUserJSON.UserId,
        this.userActivityList
      );
    }
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download in progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Observation",
        SourceId: this.observationId,
        UserId: this.loggedInUserJSON.UserId,
      },
    };
    this.observationService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }
  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_observation" + this.observationId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  cancelObservationRequest() {
    if (this.reason) {
      this.alertType = ConstantsService.Confirm;
      this.confirmMessage =
        ObservationConstantsService.Message.ObservationCancelledConfirmation;
    } else {
      this.validateCancellationRemarks = true;
    }
  }
  callbackMethodForCancelObservationRequest(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Observation Cancelled successfully"
      );
      this.router.navigate([
        ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL,
      ]);
      // this.successDetails = ObservationConstantsService.Message.ObservationCancelledSuccess;
    } else {
      this.baseService.processApiResponseError(response);
    }
  }
  ReStateObservationrequest() {
    if (this.restatereason) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ObservationRequestId: this.observationId,
          Status: ObservationConstantsService.ObservationStatus.Restate,
          Reason: this.restatereason,
        },
      };
      this.observationService.ReStateObservationrequest(
        apiRequest,
        this.callbackMethodForReStateObservationrequest.bind(this)
      );
    } else {
      this.validateCancellationRemarks = true;
    }
  }
  callbackMethodForReStateObservationrequest(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      // this.alertType = ConstantsService.Success;
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Observation Restate successfully"
      );
      this.router.navigate([
        ObservationConstantsService.RoutingURLConstant.ObservationDashboardURL,
      ]);
      // this.successDetails = ObservationConstantsService.Message.ObservationRestateSuccess;
      this.ngOnInit();
    } else {
      this.baseService.processApiResponseError(response);
    }
  }
  savePDF() {
    const apiRequest = {
      Model: {
        ProcessName:
          ObservationConstantsService.ObservationCardModuleConst.Observation,
        SourceId: this.observationId,
      },
    };
    this.observationService.savePDF(
      apiRequest,
      this.callbackMethodForSavePDF.bind(this)
    );
  }
  callbackMethodForSavePDF(response) { }
  displayImage($event, actionType, index) {
    if (ObservationConstantsService.ObservationType.didYouSee === actionType) {
      this.didYouSeeCheck =
        $event.type === ObservationConstantsService.EventType.mouseenter
          ? true
          : false;
      if (this.didYouSeeCheck) {
        this.selectedIndex = index;
      }
    } else if (
      ObservationConstantsService.ObservationType.didYouDo === actionType
    ) {
      this.didYouDoCheck =
        $event.type === ObservationConstantsService.EventType.mouseenter
          ? true
          : false;
      if (this.didYouDoCheck) {
        this.selectedIndex = index;
      }
    } else if (
      ObservationConstantsService.ObservationType.improvedType === actionType
    ) {
      this.improvedTypeCheck =
        $event.type === ObservationConstantsService.EventType.mouseenter
          ? true
          : false;
      if (this.improvedTypeCheck) {
        this.selectedIndex = index;
      }
    }
  }
  onPreviousClick() {
    this.observationIndex = -1;
    this.isNext = true;
    this.disableObservation = false;
    this.observationIds = this.observationService.getAllObservationIds();
    if(this.observationIds!=null && this.observationIds.length>0){
    if (this.observationIds) {
      this.observationIds.forEach((element, index) => {
        if (element.ObservationId === this.observationId && index - 1 != null) {
          this.observationIndex = index - 1;
          if (this.observationIndex <= 0) {
            this.isPrevious = false;
          } else {
            this.isPrevious = true;
          }
          return;
        }
      });
    }}
    if (this.observationIndex > -1) {
      this.observationId = this.observationIds[
        this.observationIndex
      ].ObservationId;
      this.unitId = this.observationIds[this.observationIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ObservationRequestId: this.observationId,
        },
      };
      this.observationService.getObservationRequest(
        apiRequest,
        this.callbackMethodForgetObservationRequest.bind(this)
      );
      this.router.navigate([
        "observation/make-observation/" + this.observationId,
        { unitId: this.unitId },
      ]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.observationIndex = -1;
    this.disableObservation = false;
    this.observationIds = this.observationService.getAllObservationIds();
    if(this.observationIds!=null&&this.observationIds.length>0){
    if (this.observationIds) {
      this.observationIds.forEach((element, index) => {
        if (element.ObservationId === this.observationId && index + 1 != null) {
          this.observationIndex = index + 1;
          if (this.observationIndex + 1 == this.observationIds.length) {
            this.isNext = false;
          } else {
            this.isNext = true;
          }
          return;
        }
      });
    }}
    if (this.observationIndex > -1) {
      this.observationId = this.observationIds[
        this.observationIndex
      ].ObservationId;
      this.unitId = this.observationIds[this.observationIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ObservationRequestId: this.observationId,
        },
      };
      this.observationService.getObservationRequest(
        apiRequest,
        this.callbackMethodForgetObservationRequest.bind(this)
      );
      this.router.navigate([
        "observation/make-observation/" + this.observationId,
        { unitId: this.unitId },
      ]);
    }
  }

  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this)
    );
  }
  callbackMethodForGetAllModules(response) {
    if (response) {
      if (response.Success) {
        this.moduleList = response.Result;
        this.moduleList.forEach((element) => {
          if (element.ModuleName === "Observation") {
            this.moduleId = element.ModuleId;
          }
        });
      }
    } else {
      this.moduleList = JSON.parse(
        this.baseService.getItemFromSession("modules")
      );
    }
  }
  categoryCheckedEmittedValue(data) {
    this.categoryCheckedValueData = data;
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.categoryCheckedValueData;
    this.specificationDetailsData.SourceId = this.refId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData,
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this)
    );
  }

  callbackMethodForSubmitSpecificationData(response) {
    if (response.Success) {
    }
  }
  showActions(actionId, processId) {
    this.router.navigate([
      "/actiontracker/all-action-details",
      actionId,
      { processId: processId },
    ]);
  }
  compareTreeNode(node, selectedNode) {
   
    var isFound: boolean = false;
    this.unitList.forEach((element) => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }  
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {

      node.selectable = false;
      node.children.forEach((element) => {
        var isFound: boolean = false;
        this.unitList.forEach((unit) => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
         
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
        
      });
    }
  }
  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  nodeSelected(event) {
    this.selectedContract = 0;
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getLocation();
    if(this.selectedUnit.UnitTypeId == 2)
    {
      this.isUnitEmployee = false;
    }
    else
    {
      this.isUnitEmployee = true;
      this.observationData.Contract = 0;
    }   
    this.getContractDetails(this.selectedUnit.UnitId);
    if (navigator.onLine) {
      this.getPermissionDetails(this.selectedUnit.UnitId);
    }
  }
  onInputFilesUpdated(files, type, index) {
    switch (type) {
      case "WhatObserved":
        this.observationData.WhatObservedFiles = files;
        break;
      case "WhatYouDid":
        this.observationData.WhatYouDidFiles = files;
        break;
      case "WhatWeCouldDo":
        this.observationData.WhatWeCouldDoFiles = files;
        break;
      case "HSEAdvisorFeedBack":
        this.observationData.HSEAdvisorFeedBackFiles = files;
        break;
      case "ObservationAction":
        for (let i = 0; i < this.actionList.length; i++) {
          if (i === index) {
            this.actionList[index].Files = files;
          }
        }
        break;
      default:
        break;
    }
  }
  saveAsDraft() {
    this.baseService.showRootLoader = true;
    if (this.IsJobStopped === "true") {
      this.observationData.IsJobStopped = true;
    } else {
      this.observationData.IsJobStopped = false;
    }
    this.validate = true;

    this.unitError = true;
    if (this.selectedUnit != undefined){
    if (this.selectedUnit.UnitId) {
      this.unitError = false;
      this.validate = true;
    }}
    // set selected Observation type
    this.selectedObsType.push(parseInt(this.observationGroup, 10));
    this.selectedObsType.push(parseInt(this.safeGroup, 10));
    this.selectedObsType.push(parseInt(this.actBehaviourGroup, 10));
    this.observationData.ObservationTypes = this.selectedObsType;

    if (this.selectedHazardTypes.length === 0) {
      this.observationData.HazardTypes = this.selectedtriangleHazardTypes;
    } else {
      this.observationData.HazardTypes = this.selectedHazardTypes;
    }
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .observationOnBehalfEmployee
    ) {
      if (this.selectedUserEmp.UserId === 0) {
        this.isEmployeeNameErrorMsg = true;
        this.validate = false;
      }
    }
    if (
      this.observationFor ===
      ObservationConstantsService.ObservationCardModuleConst
        .ObservationOnBehalfContractor
    ) {
      if (this.selectedUserContractor.UserId === 0) {
        this.isContractorNameErrorMsg = true;
        this.validate = false;
      }
    }
    if (!this.observationData.LocationId) {
      this.isLocationErrorMsg = true;
      this.validate = false;
    }
    if (!this.observationData.ObservationDate) {
      this.isObservationDateErrorMsg = true;
      this.validate = false;
    }
    if (this.observationData.ObservationTypes.length === 0) {
      this.isObservationTypeErrorMsg = true;
      this.validate = false;
    }
    if (!this.observationData.WhatObserved) {
      this.isWhatObserveErrorMsg = true;
      this.validate = false;
    }
    if (!this.observationData.WhatYouDid) {
      this.isWhatYouDidErrorMsg = true;
      this.validate = false;
    }
    if (this.actionList[0].Action) {
      if (!this.validateAddAction()) {
        this.validate = false;
      }
    }
    //BOC Pritesh 
    if(!this.isUnitEmployee && this.selectedContract == 0)
    {
      this.showContractValidation = true;
      this.validate = false;
    }
    if(!this.isUnitEmployee && this.selectedContract != 0)
    {
      this.showContractValidation = false;
    }
    //EOC Pritesh 
    if (this.validate === true) {
    this.setObservationFor();
    if (
      this.observationData.IsDraft === true &&
      this.observationId > 0 &&
      this.observationData.Status === "Draft"
    ) {
      this.observationData.IsUpdatedDraft = true;
    } else {
      this.observationData.IsUpdatedDraft = false;
    }
    this.observationData.UnitId = this.selectedUnit.UnitId;
    this.observationData.RaisedBy = this.loggedInUserJSON.UserId;
    this.observationData.IsDraft = true;
    this.observationData.LocationId = this.selectedLocation;
    //this.selectedObsType.push(parseInt(this.observationGroup, 10));
    //this.selectedObsType.push(parseInt(this.safeGroup, 10));
    //this.selectedObsType.push(parseInt(this.actBehaviourGroup, 10));
    if (this.selectedHazardTypes.length === 0) {
      this.observationData.HazardTypes = this.selectedtriangleHazardTypes;
    } else {
      this.observationData.HazardTypes = this.selectedHazardTypes;
    }
    this.observationData.ObservationTypes = this.selectedObsType;
    const apiRequest = {
      Model: this.observationData,
    };
    if (this.observationId > 0 && this.observationData.IsDraft) {
      apiRequest.Model.ObservationId = this.observationId;
      apiRequest.Model.CompanyId = this.loggedInUserJSON.Company.CompanyId;
      this.observationService.updateObservationData(
        apiRequest,
        this.callbackMethodForsubmitObservationData.bind(this)
      );
    } else {
      this.observationService.submitObservationData(
        apiRequest,
        this.callbackMethodForsubmitObservationData.bind(this)
      );
    }

  }
  else {
    this.baseService.showRootLoader = false;
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Please fill all Mandatory fields."
    );
  }
  }
  getRemarks(remarks, type, index) {
    switch (type) {
      case "DeletionReason":
        this.observationData.DeletionReason = remarks;
        break;
      case "CancellationReason":
        this.observationData.CancellationReason = remarks;
        break;
      case "WhatObserved":
        this.observationData.WhatObserved = remarks;
        break;
      case "WhatYouDid":
        this.observationData.WhatYouDid = remarks;
        break;
      case "WhatIsTheReason":
        this.observationData.WhatIsTheReason = remarks;
        break;
      case "WhatWeCouldDo":
        this.observationData.WhatWeCouldDo = remarks;
        break;
      case "Feedback":
        this.observationData.Feedback = remarks;
        break;
      case "CancellationReason":
        this.reason = remarks;
        break;
      case "RestateReason":
        this.restatereason = remarks;
        break;
      case "Action":
        this.actionList[index].Action = remarks;
        break;
      default:
        break;
    }
  }
  setLocation(location) {
    this.observationData.ExactLocation = location;
  }
  getOutput(event) {
    if (event) {
      this.router.navigate(['/observation/observation-card-overview']);
      //this.ngOnInit();
    }
  }

  //BOC Pritesh
  ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "Observation";
    this.ReportRecordId = this.observationId;
    this.ReportProcessId = this.unitId;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }

  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.PDService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }

  callbackMethodForContractDetails(response) {
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
    });
    // if (this.statisticId !== 0 && this.statisticId && this.contracts.some(c => c.value == this.statRequest.Contract)) {
    //   let currentContract = this.contracts.find(c => c.value === this.statRequest.Contract);
    //   this.CSForm.patchValue({ Contract: currentContract.value });
    //   this.checkHolder(currentContract);
    //   contractHolderId = response.find(h => h.UnitContractDetailsId === this.statRequest.Contract).ContractHolderId
      

    //   this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;    
    // }
  }

  checkHolder(event) {
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isHasContractDetails = true;
    } else {
      this.isHasContractDetails = false;
    }
    this.observationData.Contract = event.value;
  }

  //EOC Pritesh
}
export class ActionListForHSEAdvisor {
  ActionDetails: AssignActionPost[];
  SourceId: number;
  RaisedBy: number;
  ProcessName: string;
  IsDraft:boolean;
}
